/**
 * The workshops on the day picked in the phone calendar, as readable cards
 * under the grid.
 */
import { formatBlockDay } from '../../primitives/workshop-blocks';
import { WorkshopList } from '../../primitives/WorkshopList';
import type { WorkshopChip, WorkshopClickHandler } from '../../primitives/workshopsCalendarTypes';

export interface PhoneCalendarDayProps {
  /** The picked day, `YYYY-MM-DD`; null before one is picked. */
  day: string | null;
  workshops: WorkshopChip[];
  onWorkshopClick?: WorkshopClickHandler;
}

export function PhoneCalendarDay({ day, workshops, onWorkshopClick }: PhoneCalendarDayProps) {
  return (
    <section
      aria-live="polite"
      className="nb-card nb-card-tight"
      style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '14px 16px 16px' }}
    >
      {day ? (
        <>
          <h3 className="nb-display" style={{ margin: 0, fontSize: 14, letterSpacing: '.04em' }}>
            {formatBlockDay(day)}
          </h3>
          <WorkshopList
            workshops={workshops}
            onWorkshopClick={onWorkshopClick}
            emptyLabel="No workshops on this day."
          />
        </>
      ) : (
        <p style={{ margin: 0, fontSize: 12.5, color: 'var(--nb-subtle)' }}>
          Tap a day to see its workshops.
        </p>
      )}
    </section>
  );
}
